import { render, staticRenderFns } from "./incomeDetail.vue?vue&type=template&id=345ce20f&scoped=true&"
import script from "./incomeDetail.vue?vue&type=script&lang=js&"
export * from "./incomeDetail.vue?vue&type=script&lang=js&"
import style0 from "./incomeDetail.vue?vue&type=style&index=0&id=345ce20f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345ce20f",
  null
  
)

export default component.exports